/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 10:57:29
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-14 19:47:58
 */

import { API_PREFIX } from './constant'
import { Request } from './request'

// 列表
export interface DrugQualityFileListParams {
  startTime?: any
  endTime?: any
  current?: any
  size?: any
}

export function getDrugQualityFileList(
  params: DrugQualityFileListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdrugquality/list`,
    method: 'GET',
    params,
  }
}

// 详情
export function getDrugQualityFileDetail(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdrugquality/detail`,
    method: 'GET',
    params: {
      id,
    },
  }
}

// 导出
export function getDrugQualityFileExport(
  params: DrugQualityFileListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/`,
    method: 'POST',
    responseType: 'blob',
    params,
  }
}

// 保存编辑
export interface SubmitParams {
  id?: any
  tenantSupplierId?: any
  supplierName?: any
  name?: any
  tenantMaterialsCatalogId?:any
  putWay?: any
  appearanceQuality?: any
  normSituation?: any
  instockSituation?: any
  customRemark?: any
  remark?: any
  genericName?:any
}

export function getDrugQualityFileSubmit(body: SubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdrugquality/submit`,
    method: 'POST',
    body,
  }
}

// 批量添加
export function getBatchDrugQualityFileSubmit(body: SubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdrugquality/batchImport`,
    method: 'POST',
    body,
  }
}

// 删除
export function getRemove(ids: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdrugquality/del`,
    method: 'GET',
    params: {
      ids,
    },
  }
}
